import { render } from "./TagsForm.vue?vue&type=template&id=4926cce4"
import script from "./TagsForm.vue?vue&type=script&lang=js"
export * from "./TagsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__